import * as React from 'react';

import { ComboBox, useComboBoxOptions } from '@rematter/ui-web';

import {
  Account,
  useAccountsQuery,
} from '../../hooks/queries/useAccountsQuery';

import { useTranslations } from '@/transportation/i18n/useTranslations';

interface AccountSelectProps {
  label: string;
  value: string | null;
  onChange: (value: Account | null) => void;
  isRequired?: boolean;
  isDisabled?: boolean;
  isCarrier?: boolean;
}

export const AccountSelect = ({
  label,
  value,
  onChange,
  isRequired,
  isDisabled,
  isCarrier,
}: AccountSelectProps) => {
  const t = useTranslations();
  const { data } = useAccountsQuery({ isCarrier });

  const accountOptions = React.useMemo(
    () =>
      (data?.accounts ?? []).map((account) => ({
        id: account.id,
        label: account.name,
      })),
    [data?.accounts],
  );

  const { query, onChangeQuery, filteredOptions } = useComboBoxOptions({
    value: value || '',
    options: accountOptions,
    disabled: isDisabled,
  });

  const handleSelectionChange = (values: string[]) => {
    const account = data?.accounts.find((account) => account.id === values[0]);
    onChange(account ?? null);
  };

  return (
    <ComboBox
      label={label}
      value={value ? [value] : []}
      isRequired={isRequired}
      isDisabled={isDisabled}
      onChange={handleSelectionChange}
      query={query}
      onChangeQuery={onChangeQuery}
      placeholder={t.servicesView.form.placeholders.account}
      className="@AccountSelect"
      options={filteredOptions}
      getSelection={(ids) =>
        ids.map((id) => {
          const account = data?.accounts.find((a) => a.id === id);
          return { label: account?.name || '' };
        })
      }
    />
  );
};
